const PRIVILEGES_TABLE_READY = "privelege-table-ready"
const SEARCH_TEXT_STATE = "privelege-table-search-text-state"
const ROWS_PER_PAGE_STATE = "privelege-table-rows-per-page-state"
const PAGINATION_STATE = "privelege-table-pagination-state"

const PRIVELEGE_ID_FOR_ACTION = "privelege-table-brand-id-for-action"


const ADDEDIT_PRIVILEGES_READY = "privelege-table-addedit-privileges-ready"

const initialState = {
    isPrivilegesTableReady: true,
    isAddEditPrivilegesReady: true,
    privileges: {},

    
    privilegeSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case PRIVILEGES_TABLE_READY:
            return Object.assign({}, state, { isPrivilegesTableReady: action.payload })

        case ADDEDIT_PRIVILEGES_READY:
            return Object.assign({}, state, { isAddEditPrivilegesReady: action.payload })

            
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PRIVELEGE_ID_FOR_ACTION:
            return Object.assign({}, state, {privilegeSelectedId:action.payload})

        default:
        return state
    
    }

}

export function privilegesTableReady(data) {
    return {
        type: PRIVILEGES_TABLE_READY,
        payload: data
    }
}

export function addEditPrivilegesReady(data) {
    return {
        type: ADDEDIT_PRIVILEGES_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function privilegeIdForAction(privelegeId){
    return{
        type:PRIVELEGE_ID_FOR_ACTION,
        payload:privelegeId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Privileges/redux/privileges.js